export const TransactionFlowEnum = {
  WALLET_ACCOUNT: "wallet_account",
  DIRECT_WALLET: "direct_wallet",
  DIRECT_ACCOUNT: "direct_account",
}
